<template src="./forms/subject_form.html"></template>

<script>
import { CreateSubject, GetAssistItems } from '@/api/subject'

export default {
  name: 'add-subject',
  data: function () {
    return {
      model: {
        studyid: '',
        screenid: '',
        subjid: '',
        siteid: '',
        name: '',
        inver: null
      },
      id: null,
      showReviewBtn: false,
      sites: {},
      rules: {
        screenid: [{
          required: true,
          message: '筛选号不能为空',
          trigger: 'change'
        }],
        inver: [{
          required: true,
          message: '研究者不能为空',
          trigger: 'change'
        }],
        siteid: [{
          required: true,
          message: '研究中心不能为空',
          trigger: 'change'
        }],
        subjid: [{
          required: true,
          message: '受试者编号',
          trigger: 'change'
        }],
        name: [{
          required: true,
          message: '姓名拼音缩写不能为空',
          trigger: 'change'
        }]
      }
    }
  },
  created: function () {
    this.getItems()
  },
  methods: {
    handleSubmit: function (name) {
      this.model.studyid = this.$route.params.id
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.postForm()
        }
      })
    },
    getItems: function () {
      GetAssistItems(this.$route.params.id).then(async res => {
        this.sites = res.sites
      })
    },
    postForm: function () {
      CreateSubject(this.model).then(async res => {
        if (res.error) {
          this.$Message.error(res.error)
        }
        if (res.model) {
          this.showReviewBtn = true
          this.id = res.model.usubjid
          this.$Message.error(res.message)
        }
        if (res.batch === 1) {
          this.$router.push({ path: 'subject/' + res.usubjid, query: { batch: 1 } })
        } else if (res.batch === 2) {
          this.$router.push({ path: 'subject/' + res.usubjid, query: { batch: 2 } })
        }
      })
    },
    review: function () {
      this.showReviewBtn = false
      const url = '/study/' + this.$route.params.id + '/subject/' + this.id
      this.$router.push({ path: url, query: { batch: 2 } })
    }
  }
}
</script>
